import { connect } from "react-redux";
import { isBridgeSessionReady } from "../../../redux/bridge/selectors";
import CenteredSpinner from "../spinner/centered-spinner";
import React from "react";

function BridgeSessionGate({ children, sessionReady }) {
  if (sessionReady) {
    return children;
  }
  return <CenteredSpinner />;
}

const mapStateToProps = state => ({
  sessionReady: isBridgeSessionReady(state)
});

export default connect(mapStateToProps)(BridgeSessionGate);
